import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; 
import './About.css'; 
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.
function About() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">discover our story, vision, and values</h1>
            <p className="banner-description">
              Discover the story behind Shigjeta, our mission, and how we help businesses innovate and succeed.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/About Us Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>
      {/* Our Mission Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Mission</strong></h2>
            <p> At Shigjeta, we are committed to driving positive change by empowering businesses with innovative content, visualizations, and strategic advertising. From our roots in Kaçanik, we aim to support local economies and businesses worldwide, helping them achieve their goals and thrive in a rapidly changing world. </p>
          </div>
          <div className="about-image">
            <img src="/img/as1.1.png" alt="Our Mission" />
          </div>
        </div>

        {/* Our Vision Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Our Vision</strong></h2>
            <p>
            <p> At Shigjeta, we are committed to driving positive change by empowering businesses with innovative content, visualizations, and strategic advertising. From our roots in Kaçanik, we aim to support local economies and businesses worldwide, helping them achieve their goals and thrive in a rapidly changing world. </p>
            </p>
          </div>
          <div className="about-image">
            <img src="/img/as1.2.png" alt="Our Vision" />
          </div>
        </div>

        {/* Our Values Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Values</strong></h2>
            <p> At Shigjeta, our customers are at the heart of everything we do. We deeply value the trust they place in us, as they are the driving force behind our agency's creation. Before embarking on any project, we take the time to understand their unique needs. Rather than just offering services, we focus on delivering tailored solutions that help businesses improve and achieve their true potential. We are dedicated to giving our clients exactly what they need to succeed. </p>
          </div>
          <div className="about-image">
            <img src="/img/as1.3.png" alt="Our Values" />
          </div>
        </div>

        {/* Our Story Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Our Story</strong></h2>
            <p> Shigjeta was born from the combined strength of diverse skills, experiences, and a shared desire to create something new from the ground up. Our team, small but united, consists of individuals who were once employees at various companies. Tired of working for others, we decided to take control of our future and build Shigjeta together. Here, there is no "boss" – we are all equal contributors, motivated by the freedom to shape our own path. The harder we work, the greater our success. This collaborative spirit fuels our passion and drives us forward. </p>
          </div>
          <div className="about-image">
            <img src="/img/as1.4.png" alt="Our Story" />
          </div>
        </div>

        {/* Our Team Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Meet Our Team</strong></h2>
            <p>Our team is made up of passionate professionals who bring their unique talents to each project. With expertise in technology, strategy, and design, we work together to deliver exceptional results that make a lasting impact. Beyond just skills, we value creativity, collaboration, and a deep commitment to understanding our clients’ needs. Each member of our team plays a crucial role in bringing innovative ideas to life, and our collective strength is what enables us to tackle any challenge. Together, we create solutions that not only meet expectations but exceed them. </p>
          </div>
          <div className="about-image">
            <img src="/img/as1.5.png"alt="Our Team" />
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Why Choose Us</strong></h2>
            <p>
              With a client-first approach and a commitment to excellence, Shigjeta stands out for its innovative solutions, exceptional customer service, and proven track record of helping businesses succeed. Whether you're a startup or a global enterprise, we are here to help you grow.
            </p>
          </div>
          <div className="about-image">
            <img src="/img/as1.6.png" alt="Why Choose Us" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default About;
